import { useAnalytics } from '@magnetic/analytics';
import React, { forwardRef, useCallback } from 'react';

const InputWithAnalytics = forwardRef(({ analytics, label, onBlur, ...props }, ref) => {
  const { sendAnalytics } = useAnalytics();
  const handleOnBlur = useCallback(
    (event) => {
      if (analytics == null ? void 0 : analytics.events.includes("blur")) {
        sendAnalytics({
          ...analytics,
          component: "input",
          event: "blur"
        });
      }
      onBlur == null ? void 0 : onBlur(event);
    },
    [analytics, onBlur, sendAnalytics]
  );
  return /* @__PURE__ */ React.createElement("input", {
    "aria-label": label,
    ref,
    ...props,
    onBlur: handleOnBlur
  });
});
InputWithAnalytics.displayName = "Input.WithAnalytics";

export { InputWithAnalytics };
//# sourceMappingURL=input-with-analytics.js.map
